module.exports = {"id":"197117","name":"Ioannis Fetfatzidis","rating":"77","photo":"./data/images/photos/3/197117.png","club":{"name":"Al Ahli","logo":"./data/images/clubs/AlAhli.png"},"positions":["MD","AD","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IoannisFetfatzidis0.json
// module id = 1808
// module chunks = 0